export const fixSituationColors = (situation: string): string => {
    let s = situation.replaceAll("color: red", "color:red").replaceAll("color: green", "color:green")
    if (s.indexOf("color:red") < s.indexOf("color:green")) {
        s = s.replaceAll("color:red", "color:GREEN").replaceAll("color:green", "color:RED")
        s = s.replaceAll("color:GREEN", "color:green").replaceAll("color:RED", "color:red")
    }

    return s;
};